/**
 * The mouse map's bindable positions: seven fixed zone codes, in design
 * order. Zones share the Profile's positional key space with KeyboardEvent.code
 * values; the namespaces are disjoint by construction, so no prefix is needed.
 */
export const ZONE_CODES = [
  "MouseLeft",
  "MouseRight",
  "MouseMiddle",
  "WheelUp",
  "WheelDown",
  "Mouse4",
  "Mouse5",
] as const;

export type ZoneCode = (typeof ZONE_CODES)[number];

/** Fixed zone legends: zones sit outside every Keyboard Layout. */
export const ZONE_LEGENDS: Record<ZoneCode, string> = {
  MouseLeft: "LMB",
  MouseRight: "RMB",
  MouseMiddle: "MMB",
  WheelUp: "Wheel ↑",
  WheelDown: "Wheel ↓",
  Mouse4: "M4",
  Mouse5: "M5",
};

const ZONE_SET: ReadonlySet<string> = new Set(ZONE_CODES);

/** True when a positional identity is a mouse zone rather than a KeyboardEvent.code. */
export function isZone(code: string): boolean {
  return ZONE_SET.has(code);
}
